document.addEventListener('DOMContentLoaded', function() {
  
  // Unicode placeholders for icons (using custom font Private Use Area)
  const iconUnicode = {
    heartlarge: '\uE00B',        // U+E00B - Heart (large version via size multiplier)
    heartsmall: '\uE00B',        // U+E00B - Heart (small version via size multiplier)
    star: '\uE018',              // U+E018
    diamond: '\uE004',           // U+E004
    moon: '\uE010',              // U+E010
    sun: '\uE01A',               // U+E01A
    // ampersand: '\uE000',      // U+E000 - REMOVED (too big)
    pawprint: '\uE013',          // U+E013
    lightningbolt: '\uE00D',     // U+E00D
    clover: '\uE003',            // U+E003
    // rose: '\uE017',           // U+E017 - REMOVED (too big)
    martini: '\uE00F',           // U+E00F
    plane: '\uE016',             // U+E016 - Rotated to fly right
    palmtree: '\uE011',          // U+E011
    pineapple: '\uE015',         // U+E015
    // cat: '\uE001',               // U+E001 - REMOVED
    dog: '\uE006',               // U+E006
    pig: '\uE014',               // U+E014
    lips: '\uE00E',              // U+E00E
    footprints: '\uE008',        // U+E008
    // circlecross: '\uE002',    // U+E002 - REMOVED (not working)
    paperplane: '\uE012',        // U+E012
    diamondring: '\uE005',       // U+E005
    graduationhat: '\uE009',     // U+E009
    heartoutline: '\uE00C',      // U+E00C
    staroutline: '\uE019',       // U+E019
    // hashtag: '\uE00A',        // U+E00A - REMOVED (too big)
    // exclamationmark: '\uE007' // U+E007 - REMOVED (too big)
};

  // Icon size multipliers - adjust these values to make specific icons larger/smaller
  // 1.0 = default size, 1.2 = 20% larger, 0.8 = 20% smaller
  const iconSizeMultipliers = {
    heartlarge: 1.0,
    heartsmall: 0.7,
    star: 1.0,
    diamond: 1.0,
    moon: 1.0,
    sun: 1.0,
    pawprint: 1.0,
    lightningbolt: 1.0,
    clover: 1.0,
    martini: 1.0,
    plane: 1.0,
    palmtree: 1.0,
    pineapple: 1.0,
    // cat: 1.0, - REMOVED
    dog: 1.0,
    pig: 1.0,
    lips: 1.0,
    footprints: 1.0,
    paperplane: 1.0,
    diamondring: 1.0,
    graduationhat: 1.0,
    heartoutline: 1.0,
    staroutline: 1.0
  };


  
  // Check if monogram elements exist in DOM
  const monogramData = document.getElementById('monogram-data');
  const monogramWrapper = document.querySelector('.monogram-button-wrapper');
  
  // If core elements don't exist, exit (not on a product page)
  if (!monogramData || !monogramWrapper) {
    return;
  }
  
  // Get initial data from current variant (may be empty if variant doesn't support monogram)
  let xAxis = parseFloat(monogramData.dataset.xAxis) || 50;
  let yAxis = parseFloat(monogramData.dataset.yAxis) || 67;
  let fontSize = parseFloat(monogramData.dataset.fontSize) || 24; // Base font size from metafield
  let iconSize = parseFloat(monogramData.dataset.iconSize) || null; // Custom icon size (optional)
  let rotation = parseFloat(monogramData.dataset.rotation) || 0; // Rotation in degrees
  let monogramLimit = 3; // Character limit (letters, numbers, or icons) - default 3, can be overridden per variant
  const productId = monogramData.dataset.productId;
  const noIcons = monogramData.dataset.noIcons === 'true';
  
  // Note: fontSize from metafield is used as a base reference
  // Actual font size is calculated dynamically based on container width
  // to ensure consistent appearance across different viewport sizes
  
  // Monogram product variant ID
  const monogramVariantId = '52368528114027';
  
  // Color mapping with brightness levels
  const colorMap = {
    'black': { hex: '#252120', brightness: 'dark' },
    'camel': { hex: '#915733', brightness: 'medium' },
    'tan': { hex: '#af6e38', brightness: 'medium' },
    'cocoa': { hex: '#56463f', brightness: 'dark' },
    'rouge': { hex: '#9c3c3a', brightness: 'medium' },
    'powder blue': { hex: '#9fb1b7', brightness: 'light' },
    'green': { hex: '#2e4c4e', brightness: 'dark' },
    'teal': { hex: '#2e4c4e', brightness: 'dark' },
    'chalk': { hex: '#dbd6ca', brightness: 'light' },
    'khaki': { hex: '#3f4722', brightness: 'dark' },
    'buttermilk': { hex: '#ddb770', brightness: 'light' },
    'dusty rose': { hex: '#a76d66', brightness: 'medium' },
    'midnight blue': { hex: '#1a2744', brightness: 'dark' },
    'emerald': { hex: '#3a9873', brightness: 'medium' },
    'chocolate': { hex: '#2c2324', brightness: 'dark' },
    'oat': { hex: '#d7d0bd', brightness: 'light' }
  };
  
  // Elements
  const modal = document.getElementById('monogram-modal');
  const openBtn = document.getElementById('open-monogram-popup');
  const closeBtn = document.querySelector('.monogram-close');
  const monogramInput = document.getElementById('modal-monogram-text');
  const addBtn = document.getElementById('add-monogram-btn');
  const removeBtn = document.getElementById('remove-monogram-btn');
  const removeProductPageBtn = document.getElementById('remove-monogram-product-page');
  const monogramDisplay = document.getElementById('monogram-display');
  const monogramPreviewText = document.getElementById('monogram-preview-text');
  
  // Debug helper
  window.debugMonogram = function() {
    console.log('=== MONOGRAM DEBUG STATE ===');
    console.log('HTML:', monogramInput.innerHTML);
    console.log('Text Content:', monogramInput.textContent);
    console.log('Child Nodes:', monogramInput.childNodes);
    console.log('Value:', getMonogramValue());
    console.log('Count:', countVisualElements());
    console.log('Button Disabled:', addBtn.disabled);
    console.log('===========================');
  };
  
  // Helper functions for icon handling
  
  // Insert icon at cursor position in contenteditable
  function insertIconAtCursor(iconName) {
    if (noIcons) return;

    console.log('[INSERT ICON] Starting insertion of:', iconName);

    // Check if we're at the character limit
    const currentCount = countVisualElements();
    console.log('[INSERT ICON] Current count:', currentCount, 'Limit:', monogramLimit);
    if (currentCount >= monogramLimit) {
      console.log('[INSERT ICON] At limit, not inserting');
      return; // Don't insert if at limit
    }
    
    const unicode = iconUnicode[iconName];
    if (!unicode) {
      return;
    }
    
    // Create a special marker span for the icon with data attribute
    const iconSpan = document.createElement('span');
    iconSpan.setAttribute('data-icon', iconName);
    iconSpan.textContent = unicode;
    iconSpan.className = 'icon-placeholder';
    iconSpan.contentEditable = 'false'; // Make span non-editable to prevent text inside
    
    const selection = window.getSelection();
    
    // If no selection, focus the input first
    if (selection.rangeCount === 0) {
      monogramInput.focus();
      // Create a range at the end
      const range = document.createRange();
      range.selectNodeContents(monogramInput);
      range.collapse(false);
      selection.addRange(range);
    }
    
    const range = selection.getRangeAt(0);
    
    // Insert the icon span at cursor position
    range.insertNode(iconSpan);
    console.log('[INSERT ICON] Icon span inserted');
    
    // Move cursor after the inserted icon
    range.setStartAfter(iconSpan);
    range.setEndAfter(iconSpan);
    selection.removeAllRanges();
    selection.addRange(range);
    console.log('[INSERT ICON] Cursor positioned after icon');
    
    // Normalize the content to merge adjacent text nodes
    monogramInput.normalize();
    console.log('[INSERT ICON] Content normalized');
    
    // Trigger input event for preview update
    monogramInput.dispatchEvent(new Event('input'));
    console.log('[INSERT ICON] Input event triggered');
  }
  
  // Extract text/icon data from contenteditable (recursive to handle all nested content)
  function getMonogramValue() {
    console.log('[GET VALUE] Starting extraction');
    console.log('[GET VALUE] Current HTML:', monogramInput.innerHTML);
    let result = '';
    
    // Recursive function to traverse all nodes
    function traverseNode(node) {
      if (node.nodeType === Node.TEXT_NODE) {
        // Text node - add its content
        const textContent = node.textContent;
        console.log('[GET VALUE] Found text node:', textContent);
        result += textContent.toUpperCase();
      } else if (node.nodeType === Node.ELEMENT_NODE) {
        // Element node - check if it's an icon or traverse children
        if (node.tagName.toUpperCase() === 'SPAN' && node.dataset.icon) {
          // This is an icon placeholder - ONLY count the icon, not any text inside
          console.log('[GET VALUE] Found icon:', node.dataset.icon);
          result += `[${node.dataset.icon}]`;
          // Don't traverse children of icon spans - text shouldn't be there
        } else {
          // Traverse child nodes
          console.log('[GET VALUE] Traversing children of:', node.tagName);
          for (let child of node.childNodes) {
            traverseNode(child);
          }
        }
      }
    }
    
    // Start traversal from all child nodes
    for (let child of monogramInput.childNodes) {
      traverseNode(child);
    }
    
    console.log('[GET VALUE] Final result:', result);
    return result;
  }
  
  // Parse monogram string and render mixed content
  function parseMonogramContent(text) {
    console.log('[PARSE] Parsing text:', text);
    const parts = [];
    const regex = /\[([^\]]+)\]|(.)/g;
    let match;
    
    while ((match = regex.exec(text)) !== null) {
      if (match[1]) {
        // Icon
        parts.push({ type: 'icon', name: match[1] });
      } else if (match[2]) {
        // Text character
        parts.push({ type: 'text', char: match[2] });
      }
    }
    
    console.log('[PARSE] Parsed parts:', parts);
    return parts;
  }
  
  // Render monogram preview with icon font
  function renderMonogramPreview(text, color) {
    const parts = parseMonogramContent(text);
    let html = '';
    
    parts.forEach(part => {
      if (part.type === 'icon') {
        const unicode = iconUnicode[part.name];
        if (unicode) {
          // Use icon font for consistency
          html += `<span class="icon-placeholder" style="font-family: 'Monogram Icons', monospace;">${unicode}</span>`;
        } else {
          html += `[${part.name}]`; // Fallback to text if icon not found
        }
      } else {
        html += part.char;
      }
    });
    
    return `${html} (${color.charAt(0).toUpperCase() + color.slice(1)})`;
  }
  
  // Set contenteditable value from stored data
  function setMonogramValue(value) {
    console.log('[SET VALUE] Setting value:', value);
    monogramInput.innerHTML = '';
    const parts = parseMonogramContent(value);
    console.log('[SET VALUE] Parsed parts:', parts);
    
    parts.forEach(part => {
      if (part.type === 'icon') {
        const unicode = iconUnicode[part.name];
        if (unicode) {
          const iconSpan = document.createElement('span');
          iconSpan.setAttribute('data-icon', part.name);
          iconSpan.textContent = unicode;
          iconSpan.className = 'icon-placeholder';
          iconSpan.contentEditable = 'false'; // Prevent editing inside icon
          monogramInput.appendChild(iconSpan);
        }
      } else {
        const textNode = document.createTextNode(part.char);
        monogramInput.appendChild(textNode);
      }
    });
    
    // Normalize content to merge adjacent text nodes
    monogramInput.normalize();
    
    // Set cursor at the end of the content
    const selection = window.getSelection();
    const range = document.createRange();
    range.selectNodeContents(monogramInput);
    range.collapse(false); // Collapse to end
    selection.removeAllRanges();
    selection.addRange(range);
    
    // Focus the input to make it ready for editing
    monogramInput.focus();
    console.log('[SET VALUE] Input focused, ready for editing');
  }
  
  // Get a consistent storage key - use handle from URL as fallback
  function getStorageIdentifier() {
    // First try to get product ID from data attribute
    if (productId && !isNaN(productId)) {
      return productId;
    }
    
    // Use URL handle as consistent fallback
    const pathname = window.location.pathname;
    const productUrlMatch = pathname.match(/\/products\/([^\/\?]+)/);
    if (productUrlMatch) {
      return productUrlMatch[1]; // Use handle
    }
    
    // Last resort - use whatever productId we have
    return productId || 'unknown';
  }
  
  // Storage key - use consistent identifier
  const storageIdentifier = getStorageIdentifier();
  const storageKey = `monogram_${storageIdentifier}`;
  const cartAddedKey = `monogram_cart_${storageIdentifier}`;
  
  // Store original first image for restoration
  let originalFirstImage = null;
  let isMonogramProcessing = false;
  
  // Get product ID
  function getProductId() {
    // Try multiple methods to get product ID
    
    // Method 1: From the monogram data element (most reliable for this use case)
    if (productId) {
      return productId;
    }
    
    // Method 2: From data attribute
    const productElement = document.querySelector('[data-product-id]');
    if (productElement) {
      return productElement.dataset.productId;
    }
    
    // Method 3: From product form
    const productForm = document.querySelector('form[data-product-form], form[action*="/cart/add"]');
    if (productForm && productForm.dataset.productId) {
      return productForm.dataset.productId;
    }
    
    // Method 4: From meta tag
    const metaProductId = document.querySelector('meta[property="product:id"]');
    if (metaProductId) {
      return metaProductId.content;
    }
    
    // Method 5: From window object (some themes store it here)
    if (window.productId) {
      return window.productId;
    }
    
    // Method 6: Try to extract from URL patterns (some themes use /products/{id} format)
    const pathname = window.location.pathname;
    const productUrlMatch = pathname.match(/\/products\/([^\/\?]+)/);
    if (productUrlMatch) {
      // This gives us the handle, but we need the actual ID
      // For backwards compatibility, we can use the handle as an identifier
      const handle = productUrlMatch[1];
      return handle;
    }
    
    return '';
  }

  // Get product title
  function getProductTitle() {
    const titleElement = document.querySelector('h1.product__title, .product-single__title, [data-product-title], .product__name, .product-single__title h1');
    return titleElement ? titleElement.textContent.trim() : 'Product';
  }
  
  // Generate unique session ID for each monogram instance
  function generateMonogramSessionId() {
    return 'mg_' + Date.now() + '_' + Math.random().toString(36).substring(2, 11);
  }
  
  // Manage order attributes for monogram items
  async function updateOrderAttributes(action, monogramInfo) {
    try {
      // Get current cart to check existing attributes
      const cartResponse = await fetch('/cart.js');
      const cart = await cartResponse.json();
      const currentAttributes = cart.attributes || {};
      
      // Create session-based key for this monogram
      const attributeKey = `Monogram_${monogramInfo.sessionId}`;
      
      if (action === 'add') {
        // Format product with variant
        let productWithVariant = monogramInfo.productTitle;
        if (monogramInfo.variantTitle && monogramInfo.variantTitle !== 'Default Title') {
          productWithVariant = `${monogramInfo.productTitle} - ${monogramInfo.variantTitle}`;
        }
        
        // Add monogram details as single line: Text | Color | Product
        currentAttributes[attributeKey] = `${monogramInfo.monogramText} | ${monogramInfo.monogramColor} | ${productWithVariant}`;
        
      } else if (action === 'remove') {
        // Remove this specific monogram's attribute
        delete currentAttributes[attributeKey];
      }
      
      // Update cart with new attributes
      await fetch('/cart/update.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Requested-With': 'XMLHttpRequest'
        },
        body: JSON.stringify({ attributes: currentAttributes })
      });
      
    } catch (error) {
      console.error('Error updating order attributes:', error);
      // Don't throw - this is supplementary functionality
    }
  }
  
  // Sync order attributes with actual cart contents
  async function syncOrderAttributesWithCart() {
    try {
      // Get current cart
      const cartResponse = await fetch('/cart.js');
      const cart = await cartResponse.json();
      
      // Build new attributes based on actual monogram items in cart
      const newAttributes = {};
      
      // Find all monogram items (variant ID 52368528114027)
      const monogramItems = cart.items.filter(item => 
        item.variant_id === 52368528114027 || 
        String(item.variant_id) === '52368528114027'
      );
      
      // Process each monogram item
      for (const item of monogramItems) {
        if (item.properties && item.properties._session) {
          const sessionId = item.properties._session;
          const attributeKey = `Monogram_${sessionId}`;
          
          
          // Extract details from properties - FIXED property names to match what's actually set
          const monogramText = item.properties['Monogram Text'] || 
                               item.properties.Monogram || 
                               item.properties.monogram || '';
          
          const monogramColor = item.properties['Monogram Colour'] || 
                                item.properties.Colour || 
                                item.properties.Color || 
                                item.properties.color || '';
          
          const parentProduct = item.properties['For Product'] || 
                                item.properties['Parent Product'] || 
                                item.properties.product || '';
          
          // Try to get variant info from stored IDs
          let parentVariant = item.properties['Parent Variant'] || '';
          
          // If no variant info but we have variant ID, try to get it
          if (!parentVariant && item.properties['__For Variant ID']) {
            // Try to find the parent item in cart
            const variantId = item.properties['__For Variant ID'];
            const parentItem = cart.items.find(cartItem => 
              String(cartItem.variant_id) === String(variantId)
            );
            if (parentItem && parentItem.variant_title && parentItem.variant_title !== 'Default Title') {
              parentVariant = parentItem.variant_title;
            }
          }
          
          // Build the attribute value
          let productInfo = parentProduct;
          if (parentVariant && parentVariant !== 'Default Title' && parentVariant !== '') {
            productInfo = `${parentProduct} - ${parentVariant}`;
          }
          
          // Only add if we have at least some information
          if (monogramText || monogramColor || parentProduct) {
            newAttributes[attributeKey] = `${monogramText} | ${monogramColor} | ${productInfo}`;
          } else {
            // Fallback for items with no properties
            newAttributes[attributeKey] = `Monogram Service | Session: ${sessionId}`;
          }
        }
      }
      
      // Get existing attributes to preserve non-monogram ones
      const existingAttributes = cart.attributes || {};
      const preservedAttributes = {};
      
      // Keep non-monogram attributes
      for (const [key, value] of Object.entries(existingAttributes)) {
        if (!key.startsWith('Monogram_')) {
          preservedAttributes[key] = value;
        }
      }
      
      // Combine preserved attributes with new monogram attributes
      const finalAttributes = { ...preservedAttributes, ...newAttributes };
      
      // Clear any removed monogram attributes by setting them to empty string
      for (const key of Object.keys(existingAttributes)) {
        if (key.startsWith('Monogram_') && !(key in finalAttributes)) {
          finalAttributes[key] = ''; // Set to empty to clear
        }
      }
      
      // Update cart with synced attributes
      await fetch('/cart/update.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Requested-With': 'XMLHttpRequest'
        },
        body: JSON.stringify({ attributes: finalAttributes })
      });
      
      
    } catch (error) {
      // Silently handle error
    }
  }
  
  // Find the Broadcast theme's cart drawer instance
  function findCartDrawerInstance() {
    
    // Method 1: Check the theme's actual cart instance first (most reliable for Broadcast)
    if (window.cart && (window.cart.updateCart || window.cart.getCart)) {
      return window.cart;
    }
    
    // Method 2: Check theme sections instances (may be empty on first load)
    if (window.theme && window.theme.sections && window.theme.sections.instances) {
      const instances = window.theme.sections.instances;
      
      for (let key in instances) {
        if (instances[key].type === 'cart-drawer' || 
            instances[key].constructor && instances[key].constructor.name === 'CartDrawer' ||
            instances[key].updateCart ||
            instances[key].getCart) {
          return instances[key];
        }
      }
    }
    
    // Method 3: Look for Cart class instance in sections
    if (window.theme && window.theme.sections && window.theme.sections.instances) {
      for (let key in window.theme.sections.instances) {
        const instance = window.theme.sections.instances[key];
        if (instance && instance.cart && instance.getCart) {
          return instance;
        }
      }
    }
    
    // Method 4: Check for direct window.CartDrawer
    if (window.CartDrawer) {
      return window.CartDrawer;
    }
    
    // Method 5: Check for cartDrawer on window
    if (window.cartDrawer) {
      return window.cartDrawer;
    }
    
    // Method 6: Check data attributes on cart drawer element
    const cartDrawerElement = document.querySelector('[data-cart-drawer]');
    if (cartDrawerElement && cartDrawerElement.CartDrawer) {
      return cartDrawerElement.CartDrawer;
    }
    
    return null;
  }
  

  // Trigger Broadcast theme cart update - just refresh content, don't force drawer open/close
  async function triggerBroadcastCartUpdate() {
    
    try {
      // Find the cart drawer instance first
      const cartDrawer = findCartDrawerInstance();
      
      if (cartDrawer && cartDrawer.getCart) {
        // Use the theme's built-in getCart method which refreshes the cart content
        // but doesn't force the drawer to close/reopen
        await cartDrawer.getCart();
        return true;
      } else {
        
        // Fallback: Fetch cart data and dispatch theme event
        const cartResponse = await fetch('/cart.js');
        const cartData = await cartResponse.json();
        
        // Dispatch the cart change event that the theme listens to
        document.dispatchEvent(new CustomEvent('theme:cart:change', {
          bubbles: true,
          detail: { cart: cartData }
        }));
        
        return true;
      }
      
    } catch (error) {
      return false;
    }
  }
  
  // Add main product to cart with session ID for monogram tracking
  async function addMainProductWithSession(sessionId) {
    const form = document.querySelector('form[action*="/cart/add"]');
    if (!form) {
      console.error('❌ No product form found for main product');
      return;
    }
    
    const formData = new FormData(form);
    const variantId = formData.get('id');
    const quantity = parseInt(formData.get('quantity')) || 1;
    
    const mainProductData = {
      id: variantId,
      quantity: quantity,
      properties: {
        '_session': sessionId,
        '_has_monogram': 'true'
      }
    };
    
    try {
      const response = await fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Requested-With': 'XMLHttpRequest'
        },
        body: JSON.stringify(mainProductData)
      });
      
      if (!response.ok) {
        throw new Error(`Failed to add main product: ${response.status} ${response.statusText}`);
      }
      
      const result = await response.json();
      console.log('✅ [MONOGRAM] Main product added successfully:', {
        key: result.key,
        title: result.title,
        variant_id: result.variant_id
      });
      return result;
      
    } catch (error) {
      console.error('❌ [MONOGRAM] Failed to add main product:', error);
      throw error;
    }
  }

  // Add monogram product to cart (Status Anxiety optimized)
  async function addMonogramToCart(monogramData, quantity = 1, sessionId = null, variantId = null) {
    const monogramVariantIdToAdd = monogramVariantId;
    
    // Generate unique session ID if not provided
    const monogramSessionId = sessionId || generateMonogramSessionId();
    
    // Get the actual variant ID that was added (not just product ID)
    const mainVariantId = variantId || getCurrentVariantId();
    const productTitle = getProductTitle();
    const productId = getProductId();
    
    try {
      const monogramProductData = {
        id: monogramVariantIdToAdd,
        quantity: quantity,
        properties: {
          'Monogram Text': monogramData.text,
          'Monogram Colour': monogramData.color.charAt(0).toUpperCase() + monogramData.color.slice(1),
          'For Product': productTitle,
          '__For Product ID': productId,
          '__For Variant ID': mainVariantId,
          '_grouping': 'monogram-service',
          '_session': monogramSessionId,
          '__Remove Monogramming': '[Remove]'
        }
      };
      
      const response = await fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Requested-With': 'XMLHttpRequest'
        },
        body: JSON.stringify(monogramProductData)
      });
      
      if (!response.ok) {
        throw new Error(`Failed to add monogram: ${response.status} ${response.statusText}`);
      }
      
      const result = await response.json();
      console.log('✅ [MONOGRAM] Monogram added successfully:', {
        key: result.key,
        title: result.title,
        properties: result.properties
      });
      
      // Get variant title for complete product info - improved to capture size
      let variantTitle = '';
      
      // Try multiple methods to get variant details
      // Method 1: Check for size selector specifically
      const sizeSelector = document.querySelector('.product__form select[name="Size"] option:checked, .product__form input[name="Size"]:checked, [data-option-name="Size"] .variant__label--selected');
      if (sizeSelector) {
        variantTitle = sizeSelector.textContent || sizeSelector.value || '';
      }
      
      // Method 2: Check variant selector
      if (!variantTitle) {
        const variantSelector = document.querySelector('.product__form select[name="id"] option:checked, input[name="id"]:checked, .variant__label--selected');
        if (variantSelector) {
          variantTitle = variantSelector.textContent || variantSelector.dataset.title || variantSelector.getAttribute('data-variant-title') || '';
        }
      }
      
      // Method 3: Check for any selected variant options
      if (!variantTitle) {
        const selectedOptions = document.querySelectorAll('.product__form .variant__label--selected, .product__form select option:checked');
        const optionTexts = [];
        selectedOptions.forEach(option => {
          const text = option.textContent?.trim();
          if (text && text !== 'Default Title' && !optionTexts.includes(text)) {
            optionTexts.push(text);
          }
        });
        if (optionTexts.length > 0) {
          variantTitle = optionTexts.join(' / ');
        }
      }
      
      // Method 4: Try to get from variant data attributes
      if (!variantTitle && mainVariantId) {
        const currentVariant = document.querySelector(`[data-variant-id="${mainVariantId}"]`);
        if (currentVariant) {
          variantTitle = currentVariant.textContent || currentVariant.dataset.variantTitle || '';
        }
      }
      
      // Note: Order attributes will be synced when checkout is clicked
      // This avoids sync issues during shopping
      
      // Mark this monogram as added to cart for this session
      sessionStorage.setItem(cartAddedKey, 'true');
      
      // Don't trigger cart update here - let the calling function handle it
      // This avoids multiple refreshes
      
      return { result, sessionId: monogramSessionId };
      
    } catch (error) {
      // Show error message
      showMonogramErrorMessage();
      throw error;
    }
  }
  
  // Show error message
  function showMonogramErrorMessage() {
    const message = document.createElement('div');
    message.style.cssText = `
      position: fixed;
      top: 20px;
      right: 20px;
      background: #f44336;
      color: white;
      padding: 15px 20px;
      border-radius: 4px;
      z-index: 10000;
      box-shadow: 0 2px 5px rgba(0,0,0,0.2);
    `;
    message.textContent = 'Error adding monogram to cart. Please try again.';
    document.body.appendChild(message);
    
    setTimeout(function() {
      message.remove();
    }, 3000);
  }
  
  // Get variant metafield data (images and positioning)
  function getVariantMetafieldData() {
    const variantDataElement = document.getElementById('variant-metafield-data');
    if (variantDataElement) {
      try {
        const data = JSON.parse(variantDataElement.textContent);
        return data;
      } catch (e) {
        return {};
      }
    }
    return {};
  }
  
  // Update positioning data based on current variant
  function updateMonogramPositioning(variantId) {
    const variantData = getVariantMetafieldData();

    if (variantId && variantData[variantId] && variantData[variantId].monogram_position) {
      const positionData = variantData[variantId].monogram_position;
      xAxis = parseFloat(positionData.x_axis) || 50;
      yAxis = parseFloat(positionData.y_axis) || 67;
      fontSize = parseFloat(positionData.font_size) || 24;
      iconSize = positionData.icon_size ? parseFloat(positionData.icon_size) : null;
      rotation = parseFloat(positionData.degree) || 0;

      // Get character limit from variant data (default 3 if not set)
      monogramLimit = variantData[variantId].monogram_limit ? parseInt(variantData[variantId].monogram_limit) : 3;

      // Update the data attributes
      const monogramDataEl = document.getElementById('monogram-data');
      if (monogramDataEl) {
        monogramDataEl.dataset.xAxis = xAxis;
        monogramDataEl.dataset.yAxis = yAxis;
        monogramDataEl.dataset.fontSize = fontSize;
        monogramDataEl.dataset.iconSize = iconSize || '';
        monogramDataEl.dataset.rotation = rotation;
      }
      
      // Show monogram functionality
      const wrapper = document.querySelector('.monogram-button-wrapper');
      if (wrapper) {
        wrapper.style.display = 'block';
      }
      
      return true; // Has monogram data
    } else {
      // Hide monogram functionality if variant doesn't have metafield
      const wrapper = document.querySelector('.monogram-button-wrapper');
      if (wrapper) {
        wrapper.style.display = 'none';
      }
      
      // Don't clear session storage - preserve linkage for cart items
      // sessionStorage.removeItem(storageKey);
      // sessionStorage.removeItem(cartAddedKey);
      
      return false; // No monogram data
    }
  }
  
  // Get product color from title - MORE ROBUST VERSION
  function getProductColor() {
    // Try to get from product title
    const productTitle = document.querySelector('h1.product__title, .product-single__title, [data-product-title], .product__name, .product-single__title h1');
    if (productTitle) {
      const titleText = productTitle.textContent.toLowerCase();
      
      // Check each color in our map
      for (const [colorName, colorData] of Object.entries(colorMap)) {
        // For multi-word colors, just check if the title contains the color name
        if (titleText.includes(colorName)) {
          return { name: colorName, ...colorData };
        }
      }
    }
    
    // Fallback: try to get from variant selector
    const variantSelectors = document.querySelectorAll('[name="Color"], [data-option-name="Color"], select[data-option="option1"], input[type="radio"][name*="Color"], .variant-input-wrap label');
    
    for (const selector of variantSelectors) {
      let selectedColor = '';
      
      if (selector.tagName === 'SELECT') {
        selectedColor = selector.value.toLowerCase();
      } else if (selector.type === 'radio' && selector.checked) {
        selectedColor = selector.value.toLowerCase();
      } else if (selector.tagName === 'LABEL' && selector.classList.contains('active')) {
        selectedColor = selector.textContent.toLowerCase();
      }
      
      if (selectedColor && colorMap[selectedColor]) {
        return { name: selectedColor, ...colorMap[selectedColor] };
      }
    }
    
    // Additional fallback: Check for color in URL
    const urlParams = new URLSearchParams(window.location.search);
    const urlColor = urlParams.get('color');
    if (urlColor && colorMap[urlColor.toLowerCase()]) {
      return { name: urlColor.toLowerCase(), ...colorMap[urlColor.toLowerCase()] };
    }
    
    return null;
  }
  
  // Update blind emboss swatch based on product color
  function updateBlindEmbossSwatch() {
    const productColor = getProductColor();

    // Get the blind emboss option element
    const blindOption = document.querySelector('.color-option input[value="blind"]')?.closest('.color-option');

    if (!productColor) {
      // Show blind emboss if we can't determine the color
      if (blindOption) {
        blindOption.style.display = '';
      }
      return;
    }

    // Hide blind emboss option for buttermilk color
    if (productColor.name === 'buttermilk') {
      if (blindOption) {
        blindOption.style.display = 'none';

        // If blind emboss is currently selected, switch to another option
        const blindRadio = blindOption.querySelector('input[type="radio"]');
        if (blindRadio && blindRadio.checked) {
          // Select the first available color option (gold)
          const firstOption = document.querySelector('.color-option input[name="monogram-color"]:not([value="blind"])');
          if (firstOption) {
            firstOption.checked = true;
          }
        }
      }
      return;
    }

    // Show blind emboss option for all other colors
    if (blindOption) {
      blindOption.style.display = '';
    }

    // Remove any existing dynamic styles
    const existingStyle = document.getElementById('blind-swatch-dynamic-style');
    if (existingStyle) {
      existingStyle.remove();
    }

    // Create and inject new styles
    const style = document.createElement('style');
    style.id = 'blind-swatch-dynamic-style';
    style.textContent = `
      /* Override the blind emboss swatch color */
      body .color-swatch.blind::before {
        background: ${productColor.hex} !important;
        background-color: ${productColor.hex} !important;
        box-shadow:
          inset 0 2px 4px rgba(0, 0, 0, 0.4),
          inset 0 -2px 3px rgba(255, 255, 255, 0.3) !important;
      }

      /* When selected */
      body .color-option input[type="radio"]:checked + .color-swatch.blind::before {
        border-color: #333 !important;
        box-shadow:
          0 0 0 1px #333,
          inset 0 2px 4px rgba(0, 0, 0, 0.4),
          inset 0 -2px 3px rgba(255, 255, 255, 0.3) !important;
      }
    `;

    // Append to document head
    document.head.appendChild(style);
  }
  
  // Get current variant ID
  function getCurrentVariantId() {
    // Try multiple methods to get the variant ID
    // IMPORTANT: Scope searches to the main product form to avoid picking up
    // variant IDs from other forms on the page (sticky cart, quick-add, etc.)

    // Method 1: Find the hidden input linked to the main product form via form attribute
    // The theme uses: <input name="id" form="product-form-{section}-{product}">
    // which is OUTSIDE the <form> element, connected via the form attribute
    if (productId) {
      const linkedInput = document.querySelector('input[name="id"][form*="' + productId + '"]');
      if (linkedInput && linkedInput.value) {
        return linkedInput.value;
      }
    }

    // Method 2: Try the main product section wrapper
    const productSection = document.querySelector('.product__wrapper')
      || document.querySelector('[data-product-wrapper]')
      || document.querySelector('.product');
    if (productSection) {
      const scopedInput = productSection.querySelector('input[name="id"]');
      if (scopedInput && scopedInput.value) {
        return scopedInput.value;
      }
    }

    // Method 3: Try to get from URL parameters
    const urlParams = new URLSearchParams(window.location.search);
    const variantId = urlParams.get('variant');
    if (variantId) {
      return variantId;
    }

    // Method 4: Last resort - any variant input (original behavior)
    const anyVariantInput = document.querySelector('input[name="id"]');
    if (anyVariantInput && anyVariantInput.value) {
      return anyVariantInput.value;
    }

    return null;
  }
  
  // Store original image on page load
  function storeOriginalImage() {
    // Try desktop first
    let firstSlide = document.querySelector('.product__slide.is-selected');
    
    // If no desktop, try mobile
    if (!firstSlide) {
      const mobileSlider = document.querySelector('.product_mobile_slider');
      if (mobileSlider) {
        const mobileSlides = mobileSlider.querySelectorAll('.slide:not(.clone) .mobile_product__slide');
        if (mobileSlides.length > 0) {
          firstSlide = mobileSlides[0];
        }
      }
    }
    
    if (firstSlide) {
      const img = firstSlide.querySelector('img');
      if (img) {
        originalFirstImage = {
          src: img.src,
          srcset: img.srcset,
          sizes: img.sizes,
          variantId: getCurrentVariantId() // Store which variant this image is for
        };
      }
    }
  }
  
  // Apply proper emboss effect (pressed-in appearance)
  function applyProperEmboss(element, productColor) {
    // Remove any inline styles that might conflict
    element.style.color = '';
    element.style.textShadow = '';
    element.style.opacity = '';
    element.style.webkitTextStroke = '';
    
    // Add the appropriate emboss class based on color
    const colorClass = 'emboss-' + productColor.name.replace(' ', '-');
    element.classList.add(colorClass);
  }
  
  // Calculate scaled font size based on actual image size (for 1:1 images)
  function getScaledFontSize(container, baseSize) {
    // Find the actual image element
    const img = container.querySelector('img');
    if (!img) {
      // Fallback if no image found
      return baseSize;
    }

    // Get actual rendered image dimensions (will be square for 1:1)
    const imgRect = img.getBoundingClientRect();
    const imageSize = imgRect.width; // Width = Height for 1:1 images

    // If image hasn't loaded yet, use container as fallback
    if (imageSize === 0) {
      const containerWidth = container.offsetWidth;
      return Math.round(containerWidth * 0.04 * (baseSize / 24));
    }

    // Calculate font size as percentage of actual image size
    const percentage = 0.045; // 4.5% of image size
    let scaledSize = imageSize * percentage * (baseSize / 24); // Normalize to base size

    // Use a very small minimum to prevent growing effect
    const minSize = 8; // Reduced minimum
    scaledSize = Math.max(minSize, scaledSize);

    return Math.round(scaledSize);
  }

  // Get icon-specific size (uses iconSize if specified, otherwise fontSize)
  function getIconSpecificSize(container, isIcon, iconName = null) {
    let baseSize = fontSize;

    // First apply global icon size if specified
    if (isIcon && iconSize !== null && iconSize > 0) {
      baseSize = iconSize;
    }

    // Then apply icon-specific multiplier if available
    if (isIcon && iconName && iconSizeMultipliers[iconName]) {
      baseSize = baseSize * iconSizeMultipliers[iconName];
    }

    return getScaledFontSize(container, baseSize);
  }

  // Update main product image with monogram
  function updateMainProductImage() {
    const saved = sessionStorage.getItem(storageKey);

    // Check for desktop slide first
    let firstSlide = document.querySelector('.product__slide.is-selected');

    // If no desktop slide, check for mobile slide (currently visible)
    if (!firstSlide) {
      // On mobile, get the currently visible slide (index 1 is the first real slide due to cloning)
      const mobileSlider = document.querySelector('.product_mobile_slider');
      if (mobileSlider) {
        // Get all non-clone slides
        const mobileSlides = mobileSlider.querySelectorAll('.slide:not(.clone) .mobile_product__slide');
        if (mobileSlides.length > 0) {
          firstSlide = mobileSlides[0]; // Get first slide (should be the visible one)
        }
      }
    }

    if (!firstSlide) return;

    const imageWrapper = firstSlide.querySelector('.lazy-image');
    const img = firstSlide.querySelector('img');
    if (!imageWrapper || !img) return;
    
    // Remove existing overlay
    const existingOverlay = imageWrapper.querySelector('.monogram-overlay');
    if (existingOverlay) {
      existingOverlay.remove();
    }
    
    if (saved) {
      // Monogram exists - replace image and add overlay
      const data = JSON.parse(saved);
      const variantId = getCurrentVariantId();
      const variantData = getVariantMetafieldData();

      // Replace image with metafield image if available
      if (variantId && variantData[variantId] && variantData[variantId].image) {
        const metafieldImageUrl = variantData[variantId].image;
        
        // Clear srcset first to force browser to use src
        img.srcset = '';
        
        // Update image source
        img.src = metafieldImageUrl;
        
        // Generate responsive srcset for the metafield image
        const baseUrl = metafieldImageUrl.split('?')[0];
        const newSrcset = `
          ${baseUrl}?v=1&width=288 288w,
          ${baseUrl}?v=1&width=525 525w,
          ${baseUrl}?v=1&width=770 770w,
          ${baseUrl}?v=1&width=970 970w,
          ${baseUrl}?v=1&width=1200 1200w
        `.trim().replace(/\s+/g, ' ');
        
        // Set srcset after src
        setTimeout(function() {
          img.srcset = newSrcset;
        }, 10);
      }
      
      // Add monogram overlay
      const overlay = document.createElement('div');
      overlay.className = 'monogram-overlay';
      
      const monogramText = document.createElement('div');
      monogramText.className = `monogram-text ${data.color}`;
      
      // Apply proper emboss effect for blind emboss
      if (data.color === 'blind') {
        const productColor = getProductColor();
        if (productColor) {
          monogramText.setAttribute('data-product-color', productColor.name);
          applyProperEmboss(monogramText, productColor);
        } else {
          // Default emboss effect when color can't be determined
          monogramText.classList.add('emboss-default');
        }
      }
      
      // Parse and render mixed content for main product image
      const parts = parseMonogramContent(data.text);
      monogramText.innerHTML = ''; // Clear and rebuild

      // Calculate base font sizes
      const scaledTextSize = getScaledFontSize(imageWrapper, fontSize);

      parts.forEach(part => {
        if (part.type === 'icon') {
          const unicode = iconUnicode[part.name];
          if (unicode) {
            // Calculate size for this specific icon
            const scaledIconSize = getIconSpecificSize(imageWrapper, true, part.name);

            const iconSpan = document.createElement('span');
            iconSpan.className = 'icon-placeholder';
            iconSpan.setAttribute('data-icon', part.name);
            iconSpan.textContent = unicode;
            iconSpan.style.fontFamily = "'Monogram Icons', monospace"; // Ensure font is applied
            iconSpan.style.fontSize = scaledIconSize + 'px'; // Apply icon-specific size
            // Add vertical centering when icon size differs from text size
            // Only apply offset when sizes are different
            if (scaledIconSize !== scaledTextSize) {
              const offset = (scaledIconSize - scaledTextSize) * -0.1; // Negative to move up when icon is bigger
              iconSpan.style.position = 'relative';
              iconSpan.style.top = `${offset}px`;
              iconSpan.style.verticalAlign = 'middle';
            }
            monogramText.appendChild(iconSpan);
          }
        } else {
          const span = document.createElement('span');
          span.textContent = part.char;
          span.style.fontSize = scaledTextSize + 'px'; // Apply text size
          monogramText.appendChild(span);
        }
      });

      // Set base font size for the container
      monogramText.style.fontSize = scaledTextSize + 'px';
      
      monogramText.style.left = xAxis + '%';
      monogramText.style.top = yAxis + '%';
      monogramText.style.transform = `translate(-50%, -50%) rotate(${rotation}deg)`;
      
      overlay.appendChild(monogramText);
      imageWrapper.appendChild(overlay);
      
      // Update font size when image loads (in case container size changes)
      // Use a one-time listener to avoid multiple handlers
      const updateFontSizeOnLoad = function() {
        const newTextSize = getScaledFontSize(imageWrapper, fontSize);

        // Update text spans
        monogramText.querySelectorAll('span:not([data-icon])').forEach(span => {
          span.style.fontSize = newTextSize + 'px';
        });

        // Update icon spans
        monogramText.querySelectorAll('span[data-icon]').forEach(span => {
          const iconName = span.getAttribute('data-icon');
          const newIconSize = getIconSpecificSize(imageWrapper, true, iconName);
          span.style.fontSize = newIconSize + 'px';
          // Add vertical centering when icon size differs from text size
          if (newIconSize !== newTextSize) {
            const offset = (newIconSize - newTextSize) * -0.1;
            span.style.position = 'relative';
            span.style.top = `${offset}px`;
            span.style.verticalAlign = 'middle';
          }
        });

        monogramText.style.fontSize = newTextSize + 'px';
        img.removeEventListener('load', updateFontSizeOnLoad);
      };

      if (!img.complete) {
        img.addEventListener('load', updateFontSizeOnLoad);
      } else {
        // Image already loaded, update immediately
        const newTextSize = getScaledFontSize(imageWrapper, fontSize);

        // Update text spans
        monogramText.querySelectorAll('span:not([data-icon])').forEach(span => {
          span.style.fontSize = newTextSize + 'px';
        });

        // Update icon spans
        monogramText.querySelectorAll('span[data-icon]').forEach(span => {
          const iconName = span.getAttribute('data-icon');
          const newIconSize = getIconSpecificSize(imageWrapper, true, iconName);
          span.style.fontSize = newIconSize + 'px';
          // Add vertical centering when icon size differs from text size
          if (newIconSize !== newTextSize) {
            const offset = (newIconSize - newTextSize) * -0.1;
            span.style.position = 'relative';
            span.style.top = `${offset}px`;
            span.style.verticalAlign = 'middle';
          }
        });

        monogramText.style.fontSize = newTextSize + 'px';
      }
      
    } else {
      // No monogram - only restore original image if it's for the current variant
      // Otherwise, let Shopify's default image remain
      const currentVariantId = getCurrentVariantId();
      if (originalFirstImage && originalFirstImage.variantId === currentVariantId) {
        img.src = originalFirstImage.src;
        img.srcset = originalFirstImage.srcset;
        img.sizes = originalFirstImage.sizes;
      }
    }
  }
  
  // Load existing monogram from session storage
  function loadMonogram() {
    const saved = sessionStorage.getItem(storageKey);
    if (saved) {
      const data = JSON.parse(saved);
      monogramDisplay.style.display = 'block';
      monogramPreviewText.innerHTML = renderMonogramPreview(data.text, data.color);
      // Update button text
      const btnText = openBtn.querySelector('span');
      if (btnText) {
        btnText.textContent = 'Edit Monogramming';
      } else {
        // Fallback for old structure
        openBtn.textContent = 'Edit Monogramming';
      }
      updateMainProductImage();
      
      // Don't add to cart automatically - wait for main product add to cart
    }
  }
  
  // Copy first product image to modal
  function setupModalImage() {
    const variantId = getCurrentVariantId();
    const variantData = getVariantMetafieldData();
    const imageContainer = document.querySelector('.monogram-image-container');
    
    if (!imageContainer) return;
    
    // ALWAYS use metafield image in modal if available
    if (variantId && variantData[variantId] && variantData[variantId].image) {
      const metafieldImageUrl = variantData[variantId].image;
      const tempImg = new Image();
      tempImg.src = metafieldImageUrl;
      tempImg.style.width = '100%';
      tempImg.style.height = '100%';
      tempImg.style.objectFit = 'contain'; // Changed to contain for better mobile display
      tempImg.alt = 'Product image for monogram preview';
      
      // Wait for image to load before displaying
      tempImg.onload = function() {
        imageContainer.innerHTML = '';
        imageContainer.appendChild(tempImg);
      };
      
      // Handle load error
      tempImg.onerror = function() {
        // Try fallback if metafield image fails
        loadFallbackImage();
      };
    } else {
      // Use fallback directly
      loadFallbackImage();
    }
    
    // Fallback function to load alternative images
    function loadFallbackImage() {
      // Try multiple selectors for better mobile compatibility
      const selectors = [
        '.product__slide.is-selected img',
        '.product__slide img',
        '.product-single__photo img',
        '.product__photo img',
        '.product-image img',
        'img[data-product-featured-image]',
        '.product__main-photos img'
      ];
      
      let firstImage = null;
      for (const selector of selectors) {
        firstImage = document.querySelector(selector);
        if (firstImage && firstImage.src) break;
      }
      
      if (firstImage) {
        const clonedImg = firstImage.cloneNode(true);
        clonedImg.style.width = '100%';
        clonedImg.style.height = '100%';
        clonedImg.style.objectFit = 'contain';
        clonedImg.alt = 'Product image for monogram preview';
        
        // Ensure srcset and sizes are preserved for responsive images
        if (firstImage.srcset) {
          clonedImg.srcset = firstImage.srcset;
        }
        if (firstImage.sizes) {
          clonedImg.sizes = firstImage.sizes;
        }
        
        imageContainer.innerHTML = '';
        imageContainer.appendChild(clonedImg);
      } else {
        // If no image found, show a placeholder message
        imageContainer.innerHTML = '<div style="display: flex; align-items: center; justify-content: center; height: 100%; color: #999;">Product image will appear here</div>';
      }
    }
  }
  
  // Count visual elements (letters and icons count as 1 each)
  function countVisualElements() {
    console.log('[COUNT] Starting count');
    console.log('[COUNT] Current HTML:', monogramInput.innerHTML);
    let count = 0;
    
    // Recursive function to traverse all nodes
    function traverseNode(node) {
      if (node.nodeType === Node.TEXT_NODE) {
        // Text node - count its characters
        const textLength = node.textContent.length;
        console.log('[COUNT] Text node length:', textLength, 'Content:', node.textContent);
        count += textLength;
      } else if (node.nodeType === Node.ELEMENT_NODE) {
        // Element node - check if it's an icon or traverse children
        if (node.tagName.toUpperCase() === 'SPAN' && node.dataset.icon) {
          // This is an icon placeholder - count as 1, ignore any text inside
          console.log('[COUNT] Found icon:', node.dataset.icon);
          count += 1;
          // Don't traverse children of icon spans
        } else {
          // Traverse child nodes
          console.log('[COUNT] Traversing children of:', node.tagName);
          for (let child of node.childNodes) {
            traverseNode(child);
          }
        }
      }
    }
    
    // Start traversal from all child nodes
    for (let child of monogramInput.childNodes) {
      traverseNode(child);
    }
    
    console.log('[COUNT] Total count:', count);
    return count;
  }
  
  // Update preview in modal
  function updateModalPreview() {
    const text = getMonogramValue(); // Use new function to get value
    const color = document.querySelector('input[name="monogram-color"]:checked').value;
    const imageContainer = document.querySelector('.monogram-image-container');
    
    // Remove existing overlay
    const existingOverlay = imageContainer.querySelector('.monogram-overlay');
    if (existingOverlay) {
      existingOverlay.remove();
    }
    
    // Add new overlay if text exists
    if (text.length > 0) {
      const overlay = document.createElement('div');
      overlay.className = 'monogram-overlay';
      
      const monogramText = document.createElement('div');
      monogramText.className = `monogram-text ${color}`;
      
      // Apply proper emboss effect for blind emboss in preview
      if (color === 'blind') {
        const productColor = getProductColor();
        
        // Clear any previous emboss classes
        const existingEmbossClasses = Array.from(monogramText.classList).filter(c => c.startsWith('emboss-'));
        existingEmbossClasses.forEach(c => monogramText.classList.remove(c));
        
        if (productColor) {
          monogramText.setAttribute('data-product-color', productColor.name);
          applyProperEmboss(monogramText, productColor);
        } else {
          // Default emboss effect when color can't be determined
          monogramText.classList.add('emboss-default');
        }
      }
      
      // Parse and render mixed content
      const parts = parseMonogramContent(text);
      monogramText.innerHTML = ''; // Clear and rebuild

      // Calculate base font sizes for modal
      const scaledTextSize = getScaledFontSize(imageContainer, fontSize);

      parts.forEach(part => {
        if (part.type === 'icon') {
          const unicode = iconUnicode[part.name];
          if (unicode) {
            // Calculate size for this specific icon
            const scaledIconSize = getIconSpecificSize(imageContainer, true, part.name);

            const iconSpan = document.createElement('span');
            iconSpan.className = 'icon-placeholder';
            iconSpan.setAttribute('data-icon', part.name);
            iconSpan.textContent = unicode;
            iconSpan.style.fontFamily = "'Monogram Icons', monospace"; // Ensure font is applied
            iconSpan.style.fontSize = scaledIconSize + 'px'; // Apply icon-specific size
            // Add vertical centering when icon size differs from text size
            // Only apply offset when sizes are different
            if (scaledIconSize !== scaledTextSize) {
              const offset = (scaledIconSize - scaledTextSize) * -0.1; // Negative to move up when icon is bigger
              iconSpan.style.position = 'relative';
              iconSpan.style.top = `${offset}px`;
              iconSpan.style.verticalAlign = 'middle';
            }
            monogramText.appendChild(iconSpan);
          }
        } else {
          const span = document.createElement('span');
          span.textContent = part.char;
          span.style.fontSize = scaledTextSize + 'px'; // Apply text size
          monogramText.appendChild(span);
        }
      });

      // Set base font size for the container
      monogramText.style.fontSize = scaledTextSize + 'px';
      
      monogramText.style.left = xAxis + '%';
      monogramText.style.top = yAxis + '%';
      monogramText.style.transform = `translate(-50%, -50%) rotate(${rotation}deg)`;
      
      overlay.appendChild(monogramText);
      imageContainer.appendChild(overlay);
    }

    // Enable/disable add button based on character limit
    const elementCount = countVisualElements();
    addBtn.disabled = text.length === 0 || elementCount > monogramLimit;
  }
  
  // Check if user has accepted monogram terms - only show if no monogram saved
  function hasAcceptedMonogramTerms() {
    // Show acceptance popup only if no monogram is saved for this product
    const saved = sessionStorage.getItem(storageKey);
    return !!saved; // If monogram exists, consider terms accepted
  }
  
  // Handle color guide popup
  const colorGuideLink = document.getElementById('color-guide-link');
  const colorGuideModal = document.getElementById('color-guide-modal');
  const colorGuideClose = document.getElementById('color-guide-close');
  
  if (colorGuideLink && colorGuideModal) {
    colorGuideLink.addEventListener('click', function(e) {
      e.preventDefault();
      colorGuideModal.style.display = 'block';
      // Add modal-open class for mobile
      if (window.innerWidth <= 768) {
        document.body.classList.add('modal-open');
      }
    });
    
    if (colorGuideClose) {
      colorGuideClose.addEventListener('click', function() {
        colorGuideModal.style.display = 'none';
        // Remove modal-open class
        document.body.classList.remove('modal-open');
      });
    }
    
    // Close color guide modal when clicking outside
    window.addEventListener('click', function(e) {
      if (e.target === colorGuideModal) {
        colorGuideModal.style.display = 'none';
        // Remove modal-open class
        document.body.classList.remove('modal-open');
      }
    });
  }
  
  // Handle acceptance popup
  const acceptanceModal = document.getElementById('monogram-acceptance-modal');
  const acceptImage = document.getElementById('accept-image');
  
  // Function to handle acceptance
  function handleAcceptance() {
    acceptanceModal.style.display = 'none';
    modal.style.display = 'block';
    // Keep modal-open class when switching modals on mobile
    if (window.innerWidth <= 768) {
      document.body.classList.add('modal-open');
    }
    setupModalImage();
    
    // Update blind emboss swatch
    updateBlindEmbossSwatch();
    setTimeout(function() {
      updateBlindEmbossSwatch();
      const blindSwatch = document.querySelector('.color-swatch.blind');
      if (blindSwatch) {
        blindSwatch.style.display = 'none';
        blindSwatch.offsetHeight;
        blindSwatch.style.display = '';
      }
    }, 50);
    
    // Load existing data if any
    const saved = sessionStorage.getItem(storageKey);
    if (saved) {
      const data = JSON.parse(saved);
      setMonogramValue(data.text); // Use new function
      document.querySelector(`input[name="monogram-color"][value="${data.color}"]`).checked = true;
      removeBtn.style.display = 'inline-block';
    } else {
      monogramInput.innerHTML = ''; // Clear contenteditable
      document.querySelector('input[name="monogram-color"][value="gold"]').checked = true;
      removeBtn.style.display = 'none';
    }
    
    updateModalPreview();
  }
  
  // Make image clickable to accept
  if (acceptImage) {
    acceptImage.addEventListener('click', handleAcceptance);
  }
  
  // Also handle clicking anywhere on the acceptance modal to accept
  if (acceptanceModal) {
    acceptanceModal.addEventListener('click', function(e) {
      // Only accept if clicking on the modal background or the image
      if (e.target === acceptanceModal || e.target === acceptImage) {
        handleAcceptance();
      }
    });
  }
  
  // Open modal
  openBtn.addEventListener('click', function(e) {
    e.preventDefault();
    
    // Check if user has accepted terms
    if (!hasAcceptedMonogramTerms() && acceptanceModal) {
      acceptanceModal.style.display = 'block';
      // Add modal-open class for mobile
      if (window.innerWidth <= 768) {
        document.body.classList.add('modal-open');
      }
      return;
    }
    
    modal.style.display = 'block';
    // Add modal-open class for mobile
    if (window.innerWidth <= 768) {
      document.body.classList.add('modal-open');
    }
    setupModalImage();
    
    // Update blind emboss icon color - call multiple times to ensure it works
    updateBlindEmbossSwatch();
    setTimeout(function() {
      updateBlindEmbossSwatch();
      // Force a repaint of the swatch
      const blindSwatch = document.querySelector('.color-swatch.blind');
      if (blindSwatch) {
        blindSwatch.style.display = 'none';
        blindSwatch.offsetHeight; // Trigger reflow
        blindSwatch.style.display = '';
      }
    }, 50);
    
    // Load existing data if any
    const saved = sessionStorage.getItem(storageKey);
    if (saved) {
      const data = JSON.parse(saved);
      setMonogramValue(data.text); // Use new function
      document.querySelector(`input[name="monogram-color"][value="${data.color}"]`).checked = true;
      removeBtn.style.display = 'inline-block';
    } else {
      monogramInput.innerHTML = ''; // Clear contenteditable
      document.querySelector('input[name="monogram-color"][value="gold"]').checked = true;
      removeBtn.style.display = 'none';
    }
    
    updateModalPreview();
  });
  
  // Close modal
  closeBtn.addEventListener('click', function() {
    modal.style.display = 'none';
    // Remove modal-open class
    document.body.classList.remove('modal-open');
    updateMainProductImage(); // Update main image when closing
  });
  
  // Close modal when clicking outside
  window.addEventListener('click', function(e) {
    if (e.target === modal) {
      modal.style.display = 'none';
      // Remove modal-open class
      document.body.classList.remove('modal-open');
      updateMainProductImage(); // Update main image when closing
    }
  });

  // Character validation function - only allow letters, numbers, and spaces
  function isValidCharacter(char) {
    // Allow letters (A-Z, a-z), numbers (0-9), and spaces
    return /^[a-zA-Z0-9\s]$/.test(char);
  }

  // Prevent input when at character limit or invalid character
  monogramInput.addEventListener('beforeinput', function(e) {
    // Allow deletions always
    if (e.inputType === 'deleteContentBackward' || e.inputType === 'deleteContentForward') {
      return;
    }

    // Validate character type for insertText operations
    if (e.inputType === 'insertText' && e.data) {
      // Check if the character is valid (letters, numbers, spaces only)
      if (!isValidCharacter(e.data)) {
        console.log('[VALIDATION] Blocked invalid character:', e.data);
        e.preventDefault();
        return false;
      }
    }

    // Check if we're at the limit
    const currentCount = countVisualElements();
    if (currentCount >= monogramLimit) {
      e.preventDefault();
      return false;
    }
  });

  // Update preview on input and enforce character limit
  monogramInput.addEventListener('input', function() {
    console.log('[INPUT EVENT] Input changed');
    console.log('[INPUT EVENT] Before cleanup:', monogramInput.innerHTML);
    
    // Fix any text that ended up inside icon spans
    const iconSpans = monogramInput.querySelectorAll('span[data-icon]');
    iconSpans.forEach(span => {
      if (span.childNodes.length > 1 || 
          (span.childNodes.length === 1 && span.childNodes[0].nodeType === Node.TEXT_NODE && 
           span.childNodes[0].textContent !== iconUnicode[span.dataset.icon])) {
        console.log('[INPUT EVENT] Found text inside icon span, extracting...');
        // Extract any text that's not the icon unicode
        const textContent = span.textContent.replace(iconUnicode[span.dataset.icon], '');
        if (textContent) {
          // Create a text node with the extracted text
          const textNode = document.createTextNode(textContent);
          // Insert it after the icon span
          span.parentNode.insertBefore(textNode, span.nextSibling);
          // Reset the icon span to only contain the icon
          span.textContent = iconUnicode[span.dataset.icon];
        }
      }
    });
    
    // Normalize to merge adjacent text nodes
    monogramInput.normalize();
    console.log('[INPUT EVENT] After cleanup and normalize:', monogramInput.innerHTML);

    // Strip invalid characters from text nodes (handles paste operations)
    const textNodes = [];
    function collectTextNodes(node) {
      if (node.nodeType === Node.TEXT_NODE) {
        textNodes.push(node);
      } else if (node.nodeType === Node.ELEMENT_NODE) {
        // Skip icon spans, only process their siblings
        if (!(node.tagName.toUpperCase() === 'SPAN' && node.dataset.icon)) {
          for (let child of node.childNodes) {
            collectTextNodes(child);
          }
        }
      }
    }
    collectTextNodes(monogramInput);

    // Filter out invalid characters from each text node
    textNodes.forEach(textNode => {
      const originalText = textNode.textContent;
      const filteredText = originalText.replace(/[^a-zA-Z0-9\s]/g, '');
      if (originalText !== filteredText) {
        console.log('[VALIDATION] Stripped invalid characters from paste:', originalText, '->', filteredText);
        textNode.textContent = filteredText;
      }
    });

    // Enforce character limit
    const currentCount = countVisualElements();
    console.log('[INPUT EVENT] Current count:', currentCount, 'Limit:', monogramLimit);
    if (currentCount > monogramLimit) {
      // We need to trim the content to the limit
      let targetCount = monogramLimit;
      let newContent = [];
      
      // Traverse nodes and keep only what fits
      function processNode(node) {
        if (targetCount <= 0) return null;
        
        if (node.nodeType === Node.TEXT_NODE) {
          const text = node.textContent;
          if (text.length <= targetCount) {
            targetCount -= text.length;
            return node.cloneNode(true);
          } else {
            const trimmedNode = document.createTextNode(text.substring(0, targetCount));
            targetCount = 0;
            return trimmedNode;
          }
        } else if (node.nodeType === Node.ELEMENT_NODE && 
                   node.tagName.toUpperCase() === 'SPAN' && 
                   node.dataset.icon) {
          if (targetCount > 0) {
            targetCount -= 1;
            return node.cloneNode(true);
          }
        }
        return null;
      }
      
      // Process all child nodes
      for (let child of Array.from(monogramInput.childNodes)) {
        const processedNode = processNode(child);
        if (processedNode) {
          newContent.push(processedNode);
        }
        if (targetCount <= 0) break;
      }
      
      // Replace content
      console.log(`[INPUT EVENT] Trimming content to ${monogramLimit} characters`);
      monogramInput.innerHTML = '';
      newContent.forEach(node => monogramInput.appendChild(node));
      console.log('[INPUT EVENT] Content trimmed:', monogramInput.innerHTML);
      
      // Place cursor at end
      const selection = window.getSelection();
      const range = document.createRange();
      range.selectNodeContents(monogramInput);
      range.collapse(false);
      selection.removeAllRanges();
      selection.addRange(range);
      console.log('[INPUT EVENT] Cursor repositioned at end');
    }
    
    updateModalPreview();

    // Update character counter
    const count = countVisualElements();
    const counter = document.getElementById('monogram-counter');
    if (counter) {
      counter.textContent = `${count}/${monogramLimit} characters`;
    }
  });
  document.querySelectorAll('input[name="monogram-color"]').forEach(radio => {
    radio.addEventListener('change', function() {
      updateModalPreview();
      toggleBlindEmbossNotice();
    });
  });

  // Function to show/hide blind emboss notice
  function toggleBlindEmbossNotice() {
    const blindEmbossNotice = document.getElementById('blind-emboss-notice');
    const selectedColor = document.querySelector('input[name="monogram-color"]:checked');

    if (blindEmbossNotice && selectedColor) {
      if (selectedColor.value === 'blind') {
        blindEmbossNotice.style.display = 'block';
      } else {
        blindEmbossNotice.style.display = 'none';
      }
    }
  }

  // Initialize blind emboss notice visibility on page load
  toggleBlindEmbossNotice();

  // Populate icon buttons with font characters and add event listeners
  document.querySelectorAll('.icon-btn[data-icon]').forEach(button => {
    const iconName = button.dataset.icon;
    const unicode = iconUnicode[iconName];
    
    // Find the icon display span and set the unicode character
    const iconDisplay = button.querySelector('.icon-font-display');
    if (iconDisplay && unicode) {
      iconDisplay.textContent = unicode;
    }
    
    button.addEventListener('click', function(e) {
      e.preventDefault();
      console.log('[ICON BUTTON] Clicked icon:', this.dataset.icon);
      // Focus the contenteditable first
      monogramInput.focus();
      console.log('[ICON BUTTON] Input focused');
      // Insert icon at cursor
      insertIconAtCursor(this.dataset.icon);
    });
  });
  
  // Handle more icons dropdown
  const moreIconsBtn = document.getElementById('more-icons-btn');
  const moreIconsDropdown = document.getElementById('more-icons-dropdown');
  const moreIconsBackdrop = document.getElementById('more-icons-backdrop');
  const moreIconsGrid = document.getElementById('more-icons-grid');

  if (moreIconsBtn && moreIconsDropdown) {
    // Populate the dropdown with additional icons
    if (moreIconsGrid && moreIconsGrid.children.length === 0) {
      // Get icons not already shown as primary buttons
      const primaryIcons = ['heartsmall', 'heartlarge', 'sun', 'diamond'];
const additionalIcons = Object.keys(iconUnicode).filter(icon => !primaryIcons.includes(icon));
      
      // Create buttons for additional icons
      additionalIcons.forEach(iconName => {
        const btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'icon-btn';
        btn.dataset.icon = iconName;

        // Format title - special case for heartlarge
        if (iconName === 'heartsmall') {
          btn.title = 'Small Heart';
        } else {
          btn.title = iconName.charAt(0).toUpperCase() + iconName.slice(1).replace(/([A-Z])/g, ' $1');
        }

        // Use icon font instead of SVG
        const iconSpan = document.createElement('span');
        iconSpan.className = 'icon-font-display';
        iconSpan.textContent = iconUnicode[iconName] || '';

        btn.appendChild(iconSpan);

        
        btn.addEventListener('click', function(e) {
          e.preventDefault();
          insertIconAtCursor(iconName);
          moreIconsDropdown.style.display = 'none';
          if (moreIconsBackdrop) {
            moreIconsBackdrop.style.display = 'none';
            moreIconsBackdrop.classList.remove('active');
          }
        });
        
        moreIconsGrid.appendChild(btn);
      });
    }
    
    moreIconsBtn.addEventListener('click', function(e) {
      e.preventDefault();
      e.stopPropagation();
      const isOpen = moreIconsDropdown.style.display !== 'none';

      if (isOpen) {
        // Close dropdown
        moreIconsDropdown.style.display = 'none';
        if (moreIconsBackdrop) {
          moreIconsBackdrop.style.display = 'none';
          moreIconsBackdrop.classList.remove('active');
        }
      } else {
        // Open dropdown
        moreIconsDropdown.style.display = 'block';
        if (window.innerWidth <= 768 && moreIconsBackdrop) {
          moreIconsBackdrop.style.display = 'block';
          moreIconsBackdrop.classList.add('active');
        }
      }
    });

    // Close dropdown when clicking backdrop on mobile
    if (moreIconsBackdrop) {
      moreIconsBackdrop.addEventListener('click', function() {
        moreIconsDropdown.style.display = 'none';
        moreIconsBackdrop.style.display = 'none';
        moreIconsBackdrop.classList.remove('active');
      });
    }

    // Close dropdown when clicking outside (desktop) or selecting an icon
    document.addEventListener('click', function(e) {
      if (!moreIconsBtn.contains(e.target) && !moreIconsDropdown.contains(e.target)) {
        moreIconsDropdown.style.display = 'none';
        if (moreIconsBackdrop) {
          moreIconsBackdrop.style.display = 'none';
          moreIconsBackdrop.classList.remove('active');
        }
      }
    });
  }
  
  // Add monogram
  addBtn.addEventListener('click', function() {
    console.log('[ADD BUTTON] Clicked');
    const text = getMonogramValue(); // Use new function
    const color = document.querySelector('input[name="monogram-color"]:checked').value;
    console.log('[ADD BUTTON] Text:', text, 'Color:', color);
    
    if (text) {
      const monogramData = {
        text: text,
        color: color,
        timestamp: Date.now() // Add timestamp for tracking
      };
      
      // Save to session storage
      sessionStorage.setItem(storageKey, JSON.stringify(monogramData));
      console.log('[ADD BUTTON] Saved to storage:', monogramData);
      
      // Clear the cart added flag when updating monogram
      sessionStorage.removeItem(cartAddedKey);
      
      // Update display
      monogramDisplay.style.display = 'block';
      monogramPreviewText.innerHTML = renderMonogramPreview(text, color);
      // Update button text
      const btnText = openBtn.querySelector('span');
      if (btnText) {
        btnText.textContent = 'Edit Monogramming';
      } else {
        // Fallback for old structure
        openBtn.textContent = 'Edit Monogramming';
      }
      
      // Close modal and update main image
      modal.style.display = 'none';
      // Remove modal-open class
      document.body.classList.remove('modal-open');
      updateMainProductImage();
    }
  });
  
  // Remove monogram function
  function removeMonogram() {
    sessionStorage.removeItem(storageKey);
    sessionStorage.removeItem(cartAddedKey); // Clear cart added flag
    monogramDisplay.style.display = 'none';
    // Update button text with price
    const btnText = openBtn.querySelector('span');
    if (btnText) {
      const price = btnText.dataset.monogramPrice;
      btnText.textContent = price ? `Add Monogramming (${price})` : 'Add Monogramming';
    } else {
      // Fallback for old structure
      openBtn.textContent = 'Add Monogramming';
    }
    updateMainProductImage(); // Clear main image
    isMonogramProcessing = false; // Reset processing flag
  }
  
  // Remove monogram (in modal)
  removeBtn.addEventListener('click', function(e) {
    e.preventDefault();
    removeMonogram();
    modal.style.display = 'none';
    // Remove modal-open class
    document.body.classList.remove('modal-open');
  });
  
  // Remove monogram (on product page)
  if (removeProductPageBtn) {
    removeProductPageBtn.addEventListener('click', function(e) {
      e.preventDefault();
      removeMonogram();
    });
  }
  
  // Wait for Shopify to finish updating the image after variant change
  function waitForImageUpdate(callback, maxAttempts = 10) {
    let attempts = 0;
    const checkInterval = setInterval(function() {
      attempts++;
      
      // Check desktop first
      let firstSlide = document.querySelector('.product__slide.is-selected');
      
      // If no desktop, check mobile
      if (!firstSlide) {
        const mobileSlider = document.querySelector('.product_mobile_slider');
        if (mobileSlider) {
          const mobileSlides = mobileSlider.querySelectorAll('.slide:not(.clone) .mobile_product__slide');
          if (mobileSlides.length > 0) {
            firstSlide = mobileSlides[0];
          }
        }
      }
      
      const img = firstSlide ? firstSlide.querySelector('img') : null;
      
      if (img && img.complete) {
        clearInterval(checkInterval);
        callback();
      } else if (attempts >= maxAttempts) {
        clearInterval(checkInterval);
        callback(); // Call anyway after max attempts
      }
    }, 100);
  }
  
  // Handle variant changes
  document.addEventListener('change', function(e) {
    if (e.target && (e.target.name === 'id' || e.target.name === 'Color' || e.target.hasAttribute('data-option'))) {
      // Get the new variant ID
      const newVariantId = getCurrentVariantId();
      
      // Update positioning based on new variant
      const hasMonogram = updateMonogramPositioning(newVariantId);
      
      if (hasMonogram) {
        // Clear the cart added flag when variant changes - monogram needs to be re-added
        sessionStorage.removeItem(cartAddedKey);
        
        // Wait for Shopify to update the image first
        waitForImageUpdate(function() {
          const saved = sessionStorage.getItem(storageKey);
          if (saved) {
            // Force update of the main product image with new variant
            updateMainProductImage();
          }
          // Also update the blind emboss swatch when variant changes
          updateBlindEmbossSwatch();
        });
        
        // If switching from non-monogram to monogram variant, initialize
        loadMonogram();
        updateBlindEmbossSwatch();
      } else {
        // Clear any monogram overlays if variant doesn't support monogram
        const overlays = document.querySelectorAll('.monogram-overlay');
        overlays.forEach(overlay => overlay.remove());
        
        // Hide monogram display text
        if (monogramDisplay) {
          monogramDisplay.style.display = 'none';
        }
        
        // Reset button text to "Add Monogramming" with price
        const btnText = openBtn ? openBtn.querySelector('span') : null;
        if (btnText) {
          const price = btnText.dataset.monogramPrice;
          btnText.textContent = price ? `Add Monogramming (${price})` : 'Add Monogramming';
        } else if (openBtn) {
          openBtn.textContent = 'Add Monogramming';
        }
        
        // Restore original image if we have one
        let firstSlide = document.querySelector('.product__slide.is-selected');
        
        // If no desktop, check mobile
        if (!firstSlide) {
          const mobileSlider = document.querySelector('.product_mobile_slider');
          if (mobileSlider) {
            const mobileSlides = mobileSlider.querySelectorAll('.slide:not(.clone) .mobile_product__slide');
            if (mobileSlides.length > 0) {
              firstSlide = mobileSlides[0];
            }
          }
        }
        
        if (firstSlide && originalFirstImage) {
          const img = firstSlide.querySelector('img');
          if (img) {
            // Only restore if the original image was for a different variant
            // This prevents overwriting the correct variant image
            const currentVariantId = getCurrentVariantId();
            if (originalFirstImage.variantId !== currentVariantId) {
              // Let Shopify's variant image remain
            }
          }
        }
      }
    }
  });
  
  // Handle Flickity carousel changes if present
  const productSlider = document.querySelector('.product__slides');
  if (productSlider && window.Flickity) {
    const flkty = Flickity.data(productSlider);
    if (flkty) {
      flkty.on('change', function(index) {
        // Only show monogram on first slide
        if (index === 0) {
          // Add a small delay to ensure the slide is fully visible
          setTimeout(function() {
            updateMainProductImage();
          }, 100);
        } else {
          // Remove monogram from other slides
          const overlays = document.querySelectorAll('.monogram-overlay');
          overlays.forEach(overlay => overlay.remove());
        }
      });
    }
  }
  
  // Handle resize events to update monogram size
  let resizeTimeout;
  window.addEventListener('resize', function() {
    clearTimeout(resizeTimeout);
    resizeTimeout = setTimeout(function() {
      const saved = sessionStorage.getItem(storageKey);
      if (saved) {
        updateMainProductImage();
      }
    }, 250);
  });
  
  // Also listen for Shopify theme variant change events
  document.addEventListener('variant:change', function(e) {
    const newVariantId = e.detail && e.detail.variant ? e.detail.variant.id : getCurrentVariantId();
    
    // Update positioning based on new variant
    const hasMonogram = updateMonogramPositioning(newVariantId);
    
    if (hasMonogram) {
      waitForImageUpdate(function() {
        const saved = sessionStorage.getItem(storageKey);
        if (saved) {
          updateMainProductImage();
        }
        updateBlindEmbossSwatch();
      });
      
      // Initialize if switching to monogram variant
      loadMonogram();
    } else {
      // Clear any monogram overlays if variant doesn't support monogram
      const overlays = document.querySelectorAll('.monogram-overlay');
      overlays.forEach(overlay => overlay.remove());
      
      // Hide monogram display text
      if (monogramDisplay) {
        monogramDisplay.style.display = 'none';
      }
      
      // Reset button text to "Add Monogramming" with price
      const btnText = openBtn ? openBtn.querySelector('span') : null;
      if (btnText) {
        const price = btnText.dataset.monogramPrice;
        btnText.textContent = price ? `Add Monogramming (${price})` : 'Add Monogramming';
      } else if (openBtn) {
        openBtn.textContent = 'Add Monogramming';
      }
    }
  });
  
  // Listen for other possible Shopify events
  window.addEventListener('theme:variant:change', function(e) {
    const newVariantId = e.detail && e.detail.variant ? e.detail.variant.id : getCurrentVariantId();
    
    // Update positioning based on new variant
    const hasMonogram = updateMonogramPositioning(newVariantId);
    
    if (hasMonogram) {
      waitForImageUpdate(function() {
        const saved = sessionStorage.getItem(storageKey);
        if (saved) {
          updateMainProductImage();
        }
        updateBlindEmbossSwatch();
      });
      
      // Initialize if switching to monogram variant
      loadMonogram();
    } else {
      // Clear any monogram overlays if variant doesn't support monogram
      const overlays = document.querySelectorAll('.monogram-overlay');
      overlays.forEach(overlay => overlay.remove());
      
      // Hide monogram display text
      if (monogramDisplay) {
        monogramDisplay.style.display = 'none';
      }
      
      // Reset button text to "Add Monogramming" with price
      const btnText = openBtn ? openBtn.querySelector('span') : null;
      if (btnText) {
        const price = btnText.dataset.monogramPrice;
        btnText.textContent = price ? `Add Monogramming (${price})` : 'Add Monogramming';
      } else if (openBtn) {
        openBtn.textContent = 'Add Monogramming';
      }
    }
  });
  
  // Store original image, load monogram, and set initial swatch color
  storeOriginalImage();
  
  // Initialize positioning for current variant
  const initialVariantId = getCurrentVariantId();
  const hasInitialMonogram = updateMonogramPositioning(initialVariantId);
  
  // Clear cart added flag on page load to fix refresh issue
  sessionStorage.removeItem(cartAddedKey);
  
  // Intercept form.submit() calls to ensure monogram is added (current product only)
  const productForms = document.querySelectorAll('form[action*="/cart/add"]');
  productForms.forEach(form => {
    const originalSubmit = form.submit;
    form.submit = function() {
      // Only consider monogram saved for this product
      let savedMonogram = sessionStorage.getItem(storageKey);

      const wasAlreadyAdded = sessionStorage.getItem(cartAddedKey) === 'true';

      // Only intercept if current variant supports monogram
      const supportsMonogram = updateMonogramPositioning(getCurrentVariantId());

      if (savedMonogram && !wasAlreadyAdded && !isMonogramProcessing && supportsMonogram) {
        // Instead of direct submit, handle with our custom function
        handleCustomAddToCart(form, savedMonogram);
        return; // Don't call original submit
      }

      // Call original submit if no monogram or not supported
      originalSubmit.call(this);
    };
  });
  
  // Only load monogram if variant supports it
  if (hasInitialMonogram) {
    loadMonogram();
    updateBlindEmbossSwatch();
    
    // Ensure metafield image shows immediately after page load
    setTimeout(function() {
      const saved = sessionStorage.getItem(storageKey);
      if (saved) {
        updateMainProductImage();
      }
    }, 100);
  }
  
  // Try updating again after DOM is fully loaded
  setTimeout(function() {
    updateBlindEmbossSwatch();
  }, 200);
  
  
  // Custom add to cart handler with session tracking
  async function handleCustomAddToCart(form, savedMonogramData, button = null) {
    try {
      isMonogramProcessing = true;
      const monogramData = JSON.parse(savedMonogramData);
      const sessionId = generateMonogramSessionId();
      
      // Get quantity and variant ID from form
      const formData = new FormData(form);
      const quantity = parseInt(formData.get('quantity')) || 1;
      const variantId = formData.get('id') || getCurrentVariantId();
      
      // Add both products in sequence
      await addMainProductWithSession(sessionId);
      await new Promise(resolve => setTimeout(resolve, 500));
      await addMonogramToCart(monogramData, quantity, sessionId, variantId);
      await new Promise(resolve => setTimeout(resolve, 300));
      
      // Dispatch event to track when items were added
      window.dispatchEvent(new CustomEvent('monogram:items-added'));
      
      // Trigger cart update
      await triggerBroadcastCartUpdate();
      
      // Show success state briefly
      if (button) {
        button.classList.remove('btn--loading');
        button.classList.add('btn--added');
        setTimeout(() => {
          button.classList.remove('btn--added');
          button.disabled = false;
        }, 1000);
      }
      
    } catch (error) {
      // Clear loading state on error
      if (button) {
        button.classList.remove('btn--loading');
        button.disabled = false;
      }
      // Fallback to normal form submission
      form.submit();
    } finally {
      isMonogramProcessing = false;
    }
  }
  
  // Broadcast Theme Cart Integration
  // Handle both AJAX and regular form submissions with monogram
  
  // Intercept add to cart button clicks BEFORE theme processes them (current product only)
  document.addEventListener('click', function(e) {
    // Check if this is an add to cart button
    const button = e.target.closest('[data-add-to-cart], button[type="submit"], input[type="submit"], .btn--add-to-cart, .product-form__cart-submit, .product__add-to-cart');
    
    if (button) {
      const form = button.closest('form[action*="/cart/add"]');
      if (form) {
        // Only consider monogram saved for this product
        let savedMonogram = sessionStorage.getItem(storageKey);
        
        const wasAlreadyAdded = sessionStorage.getItem(cartAddedKey) === 'true';
        
        // If we have monogram and haven't added it yet, intercept the click
        // Only intercept when current variant supports monogram
        const supportsMonogram = updateMonogramPositioning(getCurrentVariantId());
        if (savedMonogram && !wasAlreadyAdded && !isMonogramProcessing && supportsMonogram) {
          e.preventDefault();
          e.stopPropagation();
          e.stopImmediatePropagation();
          
          // Trigger loading state on button
          button.classList.add('btn--loading');
          button.disabled = true;
          
          // Handle with our custom function
          handleCustomAddToCart(form, savedMonogram, button);
          return false;
        }
      }
    }
  }, true); // Use capture phase to intercept before other handlers
  
  // Listen for theme's successful product addition events as backup (current product only)
  document.addEventListener('theme:product:added', async function(e) {
    let savedMonogram = sessionStorage.getItem(storageKey);
    const wasAlreadyAdded = sessionStorage.getItem(cartAddedKey) === 'true';
    const supportsMonogram = updateMonogramPositioning(getCurrentVariantId());
    if (savedMonogram && !wasAlreadyAdded && !isMonogramProcessing && supportsMonogram) {
      try {
        isMonogramProcessing = true;
        const monogramData = JSON.parse(savedMonogram);
        
        // Get quantity and variant ID from the form or event
        let quantity = 1;
        let variantId = null;
        
        // First try to get from event detail
        if (e.detail) {
          if (e.detail.quantity) {
            quantity = e.detail.quantity;
          }
          if (e.detail.variant || e.detail.variantId || e.detail.id) {
            variantId = e.detail.variant || e.detail.variantId || e.detail.id;
          }
        }
        
        // Fallback to form data
        const form = document.querySelector('form[action*="/cart/add"]');
        if (form) {
          const formData = new FormData(form);
          quantity = parseInt(formData.get('quantity')) || quantity;
          
          // Get variant ID from form if not in event
          if (!variantId) {
            variantId = formData.get('id') || getCurrentVariantId();
          }
        }
        
        // If still no variant ID, get current variant
        if (!variantId) {
          variantId = getCurrentVariantId();
        }
        
        // Generate session ID for grouping both items together
        const sessionId = generateMonogramSessionId();
        
        // Add monogram with the same session ID and variant reference
        await addMonogramToCart(monogramData, quantity, sessionId, variantId);
        await triggerBroadcastCartUpdate();
        
      } catch (error) {
        // Error adding monogram
      } finally {
        isMonogramProcessing = false;
      }
    }
  });
  
  // For regular form submissions (when cart drawer is disabled) - current product only
  document.addEventListener('submit', function(e) {
    const form = e.target;
    
    // Check if this is a product add to cart form and has monogram
    if (form && form.action && form.action.includes('/cart/add')) {
      // Only consider monogram saved for this product
      let savedMonogram = sessionStorage.getItem(storageKey);
      
      const wasAlreadyAdded = sessionStorage.getItem(cartAddedKey) === 'true';
      
      // Check if cart drawer is disabled (regular form submission mode)
      const isAjaxMode = window.theme && window.theme.settings && window.theme.settings.cartDrawerEnabled;
      
      if (savedMonogram && !wasAlreadyAdded && !isMonogramProcessing && !isAjaxMode && updateMonogramPositioning(getCurrentVariantId())) {
        e.preventDefault(); // Prevent default form submission
        e.stopPropagation();
        
        // Handle custom add to cart with session tracking
        handleCustomAddToCart(form, savedMonogram);
      }
    }
  });
  
  // Monitor cart updates to ensure monogram shows
  const cartObserver = new MutationObserver(function(mutations) {
    mutations.forEach(function(mutation) {
      if (mutation.type === 'childList') {
        // Check if cart was updated
        const cartContent = document.querySelector('[data-api-content]');
        if (cartContent && cartContent.contains(mutation.target)) {
          // Cart content was updated
        }
      }
    });
  });
  
  // Start observing cart drawer for changes
  const cartDrawerElement = document.querySelector('[data-cart-drawer]');
  if (cartDrawerElement) {
    cartObserver.observe(cartDrawerElement, {
      childList: true,
      subtree: true
    });
  }
  
  
  
  // Listen for cart drawer open events and refresh if needed
  let lastCartRefresh = 0;
  const cartDrawerEl = document.querySelector('[data-cart-drawer]');
  
  if (cartDrawerEl) {
    // Use MutationObserver to detect when cart drawer opens
    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
          const isOpen = cartDrawerEl.classList.contains('is-open') || 
                        cartDrawerEl.classList.contains('is-visible') ||
                        cartDrawerEl.classList.contains('drawer--open');
          
          if (isOpen) {
            const now = Date.now();
            // If cart was opened within 3 seconds of adding monogram, refresh it
            if (now - lastCartRefresh < 3000 && sessionStorage.getItem(storageKey)) {
              // Check if monogram is visible in cart
              setTimeout(() => {
                const monogramInCart = document.querySelector('.cart__item__monogram');
                if (!monogramInCart && sessionStorage.getItem(cartAddedKey) === 'true') {
                  triggerBroadcastCartUpdate();
                }
              }, 100);
            }
          }
        }
      });
    });
    
    observer.observe(cartDrawerEl, { attributes: true });
  }
  
  // Track when we add items
  window.addEventListener('monogram:items-added', () => {
    lastCartRefresh = Date.now();
  });
  
  // Handle cart item removal - remove both parent and monogram items together
  document.addEventListener('click', async function(e) {
    // Check if this is a cart remove button
    const removeBtn = e.target.closest('[data-item-remove]');
    if (!removeBtn) return;

    // Handle monogram-specific remove buttons differently
    if (removeBtn.classList.contains('cart__item__monogram-remove')) {
      // Get the monogram item being removed
      try {
        const cartResponse = await fetch('/cart.js');
        const cart = await cartResponse.json();
        const lineItemKey = removeBtn.dataset.id;

        if (lineItemKey) {
          const monogramItem = cart.items.find(item => item.key === lineItemKey);
          if (monogramItem && monogramItem.properties) {
            // Clear saved monogram state for this product so it doesn't get re-added
            const pid = monogramItem.properties['__For Product ID'];
            if (pid) {
              try {
                sessionStorage.removeItem(`monogram_${pid}`);
                sessionStorage.removeItem(`monogram_cart_${pid}`);
              } catch (e) {
                // ignore storage errors
              }
            }
            // Note: Order attributes will be synced when checkout is clicked
          }
        }
      } catch (error) {
        console.error('Error handling monogram removal:', error);
      }
      return; // Let the normal removal happen
    }
    
    try {
      // Get current cart data
      const cartResponse = await fetch('/cart.js');
      const cart = await cartResponse.json();
      
      // Get the line item key being removed
      const lineItemKey = removeBtn.dataset.id;
      if (!lineItemKey) return;
      
      // Find the item being removed
      const itemToRemove = cart.items.find(item => item.key === lineItemKey);
      if (!itemToRemove || !itemToRemove.properties) return;
      
      // Check if this item has a monogram
      if (itemToRemove.properties._has_monogram === 'true' && itemToRemove.properties._session) {
        e.preventDefault();
        e.stopPropagation();
        
        const sessionId = itemToRemove.properties._session;
        
        // Find the monogram service item with matching session
        const monogramItem = cart.items.find(item => 
          item.properties && 
          item.properties._session === sessionId && 
          item.properties._grouping === 'monogram-service'
        );
        
        if (monogramItem) {
          // Disable the remove button to prevent double-clicks
          removeBtn.classList.add('is-loading');
          removeBtn.disabled = true;
          
          // Prepare updates to remove both items
          const updates = {};
          updates[lineItemKey] = 0; // Remove parent item
          updates[monogramItem.key] = 0; // Remove monogram item
          
          // Update cart to remove both items
          const updateResponse = await fetch('/cart/update.js', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              'X-Requested-With': 'XMLHttpRequest'
            },
            body: JSON.stringify({ updates })
          });
          
          if (updateResponse.ok) {
            // Remove order attributes for this monogram
            await updateOrderAttributes('remove', {
              sessionId: sessionId
            });
            // Clear any saved monogram state for this product id so it doesn't re-add later
            try {
              const pid = itemToRemove && itemToRemove.properties ? (itemToRemove.properties['__For Product ID'] || itemToRemove.product_id) : null;
              if (pid) {
                sessionStorage.removeItem(`monogram_${pid}`);
                sessionStorage.removeItem(`monogram_cart_${pid}`);
              }
            } catch (e) {
              // ignore storage errors
            }
            
            // Trigger cart refresh
            const cartDrawer = findCartDrawerInstance();
            if (cartDrawer && cartDrawer.getCart) {
              await cartDrawer.getCart();
            } else {
              // Fallback: dispatch cart change event
              const updatedCart = await updateResponse.json();
              document.dispatchEvent(new CustomEvent('theme:cart:change', {
                bubbles: true,
                detail: { cart: updatedCart }
              }));
            }
            
            // If on cart page, reload
            if (window.location.pathname === '/cart') {
              window.location.reload();
            }
          } else {
            // Re-enable button on error
            removeBtn.classList.remove('is-loading');
            removeBtn.disabled = false;
          }
        }
      }
    } catch (error) {
      console.error('Error removing linked cart items:', error);
    }
  });
  
  // Intercept checkout button clicks to sync order attributes
  document.addEventListener('click', async function(e) {
    // Check if this is a checkout button
    const checkoutBtn = e.target.closest('.cart__checkout, button[name="checkout"], a[href="/checkout"]');
    
    if (!checkoutBtn) return;
    
    // Don't intercept the "View Cart" button
    if (checkoutBtn.textContent && checkoutBtn.textContent.includes('View Cart')) {
      return;
    }
    
    // Prevent default checkout action
    e.preventDefault();
    e.stopPropagation();
    
    
    // Show loading state
    const originalDisabled = checkoutBtn.disabled;
    checkoutBtn.disabled = true;
    if (!checkoutBtn.classList.contains('btn--loading')) {
      checkoutBtn.classList.add('btn--loading');
    }
    
    try {
      // Sync order attributes with cart
      await syncOrderAttributesWithCart();
      
      // Small delay to ensure sync is complete
      await new Promise(resolve => setTimeout(resolve, 500));
      
      
      // Proceed with checkout
      if (checkoutBtn.tagName === 'A') {
        // If it's a link, navigate to checkout
        window.location.href = '/checkout';
      } else if (checkoutBtn.type === 'submit') {
        // If it's a submit button, submit the form
        const form = checkoutBtn.closest('form');
        if (form) {
          // Create a new submit button that won't be intercepted
          const tempSubmit = document.createElement('input');
          tempSubmit.type = 'submit';
          tempSubmit.name = 'checkout';
          tempSubmit.style.display = 'none';
          form.appendChild(tempSubmit);
          tempSubmit.click();
          form.removeChild(tempSubmit);
        } else {
          // Fallback to direct navigation
          window.location.href = '/checkout';
        }
      } else {
        // Default to checkout navigation
        window.location.href = '/checkout';
      }
    } catch (error) {
      // Still proceed to checkout even if sync fails
      window.location.href = '/checkout';
    } finally {
      // Restore button state (in case navigation is cancelled)
      checkoutBtn.disabled = originalDisabled;
      checkoutBtn.classList.remove('btn--loading');
    }
  }, true); // Use capture phase to intercept before other handlers
  
});
